export default "__VITE_ASSET__DKGQRkbx__"